import { ModuleBase } from '../../shared/modules';
import { routes } from '../art/routes';

export class ArtModule extends ModuleBase {
  constructor() {
    super({ routes });
  }
}
